import RequestAbstract from "./RequestAbstract";

export default class ClientRelations extends RequestAbstract {
    get link() {
        return this.links.clientRelations;
    }

    async updateRalation(info) {
        const res = await this.post(this.link + "/update-by-ids", info);
        return res;
    }
}
